import { Loading, Menu, NotFound } from '@/components'
import { raundUrl } from '@/lib/custom'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useChangeLanguage } from '@/lib/useChangeLanguage'
import useDeployTimeStamp from '@/lib/useDeployTimeStamp'
import { useFetchGet } from '@/lib/useFetch'
import { useLocalStorageClear } from '@/lib/useLocalStorageClear'
import useNoLogin from '@/lib/useNoLogin'
import { usePeriod } from '@/lib/usePeriod'
import type { RootState } from '@/store/store'
import styles from '@/styles/Home.module.scss'
import Head from 'next/head'
import { useRouter } from 'next/router'
import type React from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useSWR from 'swr'
import RegisterQuestionnaire from './RegisterQuestionnaire'

type LayoutTYPE = {
  children: React.ReactNode
  title: string
  // footerのメニューを表示させるかどうかのフラグ
  showMenu?: boolean
}

export const Layout = ({ children, title, showMenu = true }: LayoutTYPE) => {
  const { LOCAL_STORAGE_CLIENT_ID_KEY, LOCAL_STORAGE_JWT_KEY, gen } = useCampaignSlug()
  const { t } = useTranslation()
  const clear = useLocalStorageClear()

  const { getWithoutAuth: campaignGet } = useFetchGet<{ campaign: Api.CampaignResBody }>({})
  const { data: campaignData } = useSWR<{ campaign: Api.CampaignResBody }>(raundUrl.campaign, campaignGet)
  // redux state
  const periodSelector = useSelector((state: RootState) => state.auth.period)
  // const pageToggleSelector = useSelector((state: RootState) => state.auth.pageToggle)
  const dialogRegisterQuestionnaireStateSelector = useSelector(
    (state: RootState) => state.dialog.dialogRegisterQuestionnaireState,
  )

  const { getWithAuth: getUser } = useFetchGet<Api.UserResBody>({ isTokenRefresh: false })

  const router = useRouter()
  const { route } = router

  useDeployTimeStamp()
  const { campaignIsOpen, loadingCampaignIsOpen } = usePeriod({ campaign: campaignData?.campaign })
  useNoLogin()
  useChangeLanguage({ campaign: campaignData?.campaign })

  useEffect(() => {
    if (typeof window !== 'undefined' ? localStorage.getItem(LOCAL_STORAGE_CLIENT_ID_KEY) : '') {
      if (localStorage.getItem(LOCAL_STORAGE_JWT_KEY)) {
        // dispatch(pageToggleState(true))
        return
      }

      if (router.pathname === '/[campaign]/auth/signin') {
        setTimeout(() => {
          // dispatch(pageToggleState(true))
        }, 500)
        return
      }

      if (router.pathname === '/[campaign]/auth/register') {
        setTimeout(() => {
          // dispatch(pageToggleState(true))
        }, 500)
        return
      }
    } else {
      if (router.pathname === '/[campaign]/auth/register') {
        setTimeout(() => {
          // dispatch(pageToggleState(true))
        }, 500)

        return
      }

      if (router.pathname === '/[campaign]/auth/signin') {
        setTimeout(() => {
          // dispatch(pageToggleState(true))
        }, 500)
      }

      return
    }
    return
  }, [])

  useEffect(() => {
    try {
      getUser(raundUrl.user).then((userState: Api.UserResBody) => {
        if (userState && userState.user && userState.campaign) {
          if (!userState.user?.login && userState.campaign.custom === 'NTT') {
            clear()
            location.href = gen('/auth/signin')
          }
        }
      })
    } catch (error) {}
  }, [])

  useEffect(() => {
    // ローカルだと正しく動いていないように見えるので注意すること
    // 2025-09-03時点のCloudFront + Lambda@Edgeの構成で正しく動く
    if (campaignData && campaignData['status'] === 404) {
      location.href = gen('/404')
    }
  }, [campaignData])

  const handleRouteError = (err, url) => {
    if (err.cancelled) {
      console.log(`Route to ${url} was cancelled!`)
    }
  }

  const isHideHeader = (path: string): boolean => {
    const hideHeaderPaths = [
      '/notice',
      '/logout',
      '/qrerror',
      '/404',
      '/500',
      '/auth/register',
      '/auth/changeForcePassword',
      '/auth/signin',
    ]
    return hideHeaderPaths.map((v) => path.startsWith(`/[campaign]${v}`)).some((v) => v) || path === '/[campaign]'
  }

  const isHideMenu = (path: string): boolean => {
    const hideMenuPaths = [
      '/auth/register',
      '/auth/changeForcePassword',
      '/auth/signin',
      '/logout',
      '/notice',
      '/qr',
      '/qrerror',
      '/404',
      '/500',
    ]
    return hideMenuPaths.map((v) => path.startsWith(`/[campaign]${v}`)).some((v) => v)
  }

  const isHideRegisterQuestionnaire = (path: string): boolean => {
    const hideRQPaths = ['/auth/register', '/auth/signin', '/logout', '/notice', '/qr', '/qrerror', '/404', '/500']
    return hideRQPaths.map((v) => path.startsWith(`/[campaign]${v}`)).some((v) => v)
  }

  useEffect(() => {
    router.events.on('routeChangeError', handleRouteError)
    return () => {
      router.events.off('routeChangeError', handleRouteError)
    }
  }, [router.events])

  if (router.pathname.includes('/500')) {
    return <>{children}</>
  }

  // if (campaignData && campaignData['status'] === 404) return <NotFound withHome={false} />
  if (loadingCampaignIsOpen) {
    return <Loading />
  }
  if (!campaignIsOpen) {
    return (
      <>
        <div className="c-contents bg-white px-4 pt-4 pb-6">
          {campaignData?.campaign && campaignData.campaign.outOfTermMessage !== undefined ? (
            <section
              className={`${styles.c_rule} ${styles.c_notice} rounded-[4px] border-[2px] border-main to-white py-4 px-4`}
              dangerouslySetInnerHTML={{
                __html: campaignData.campaign.outOfTermMessage,
              }}
            />
          ) : (
            ''
          )}
        </div>
      </>
    )
  }

  return (
    <div
      className={`c-wrapper ${periodSelector ? 'opacity-1' : 'opacity-0'} ${route === '/spot' ? 'height-auto' : ''}`}
    >
      <Head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"
        />
        <title>{title}</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;1,700&display=swap"
          rel="stylesheet"
        />
      </Head>
      {(() => {
        if (isHideHeader(router.pathname)) {
          return
        }
        return (
          <header id="l_header" className="bg-header">
            <nav className="bg-white w-screen">
              <div className="flex items-center">
                <div className="flex w-full px-3 py-3">
                  <button
                    type="button"
                    className="flex items-center"
                    onClick={(e) => {
                      e.preventDefault()

                      // QRコードなどで読み込んだ直後は3遷移いないのため
                      // 遷移がすでにあるのが多少気持ち悪いが、referrerの存在確認よりはまともな挙動をするため
                      const INITIAL_ACCESS_HISTORY_LENGTH = 4
                      if (
                        window.history.length <= INITIAL_ACCESS_HISTORY_LENGTH ||
                        document.referrer.includes('/qr/')
                      ) {
                        router.push(gen('/'))
                        return
                      }

                      router.back()
                      return
                    }}
                  >
                    ＜<span className="ml-4 block text-xsss font-bold text-color01">{t('common.back', '戻る')}</span>
                  </button>
                </div>
              </div>
            </nav>
          </header>
        )
      })()}
      <main>
        {isHideMenu(router.pathname) || !showMenu ? '' : <Menu />}
        {children}
        <style global jsx>{`
          :root {
            --env-url: ${process.env.NEXT_PUBLIC_SITEURL};
          }
        `}</style>
      </main>

      {isHideRegisterQuestionnaire(router.pathname) ? null : dialogRegisterQuestionnaireStateSelector ? (
        <RegisterQuestionnaire />
      ) : null}
    </div>
  )
}
